import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "auto", fontFamily: "Arial, sans-serif", lineHeight: "1.7" }}>
      <h1>Privacy Policy</h1>
      <p>
        At <strong>Jyotirvani.com</strong>, your privacy is important to us. We respect your trust and are fully committed to protecting the personal information you share with us.
        This Privacy Policy explains what data we collect, how we use it, and how we keep it safe when you use our website and services.
      </p>

      <hr />

      <h2>1. What Information Do We Collect?</h2>
      <p>To offer you personalized astrological services, we may collect the following:</p>
      <ul>
        <li><strong>Basic Details:</strong> Your name, email address, phone number, gender, date & place of birth.</li>
        <li><strong>Astrological Information:</strong> Your birth details to create your horoscope or reports.</li>
        <li><strong>Payment Info:</strong> Billing details and transaction history (we don’t store your card or banking details — payments are processed securely through trusted gateways).</li>
        <li><strong>Browsing Info:</strong> Your IP address, device/browser details, the pages you visit, and time spent on the site.</li>
      </ul>

      <hr />

      <h2>2. How We Use Your Information</h2>
      <p>We use your information thoughtfully and only for legitimate purposes such as:</p>
      <ul>
        <li>Creating accurate astrological readings and reports.</li>
        <li>Communicating with you about your bookings or inquiries.</li>
        <li>Sending occasional updates or offers (only if you choose to receive them).</li>
        <li>Improving our website, services, and customer experience.</li>
        <li>Processing your payments and providing support when needed.</li>
      </ul>

      <hr />

      <h2>3. Do We Share Your Information?</h2>
      <p>No. We do not sell or rent your personal data.</p>
      <p>We may share your information only in the following cases:</p>
      <ul>
        <li>With trusted partners (like payment processors or customer support tools) who help us run our services smoothly — and they’re bound by confidentiality.</li>
        <li>If legally required by law enforcement or court orders.</li>
        <li>To protect our rights or in case of any fraud or security concerns.</li>
      </ul>

      <hr />

      <h2>4. Cookies & Tracking Tools</h2>
      <p>
        Like most websites, we use cookies to give you a better experience and understand how visitors use our site.
        You can always adjust your cookie preferences through your browser settings.
      </p>

      <hr />

      <h2>5. Keeping Your Data Safe</h2>
      <p>
        We take your data security seriously. We use strong security practices to protect your information from unauthorized access or misuse.
        However, no method of internet transmission is 100% secure, so we always recommend caution while sharing sensitive details online.
      </p>

      <hr />

      <h2>6. Your Rights</h2>
      <p>You have full control over your data. You can:</p>
      <ul>
        <li>Ask us what data we hold about you.</li>
        <li>Request edits or deletion of your personal information.</li>
        <li>Opt out of marketing emails anytime by clicking “unsubscribe” in the message or contacting us.</li>
      </ul>
      <p>
        To do any of this, just drop us an email at <strong>support@jyotirvani.com</strong>.
      </p>

      <hr />

      <h2>7. Links to Other Sites</h2>
      <p>
        Our website may include links to third-party sites. We’re not responsible for how those websites handle your data,
        so we recommend reading their privacy policies too.
      </p>

      <hr />

      <h2>8. For Children Under 18</h2>
      <p>
        Our services are designed for adults. If you’re under 18, please use the site only with parental guidance.
        We do not knowingly collect information from minors.
      </p>

      <hr />

      <h2>9. Updates to This Policy</h2>
      <p>
        We may revise this Privacy Policy as needed. If we make changes, we’ll update the date at the top and post the revised version here.
        Please check back occasionally to stay informed.
      </p>

      <hr />

      <h2>10. Get in Touch</h2>
      <p>If you have questions, concerns, or need help with your data, please contact us:</p>
      <ul>
        <li><strong>📧 Email:</strong> support@jyotirvani.com</li>
        <li><strong>🌐 Website:</strong> <a href="https://www.jyotirvani.com" target="_blank" rel="noopener noreferrer">www.jyotirvani.com</a></li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
